import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CmsModalService} from '../../core/modal.service';
import {CmsNotifyService} from '../../core/notify.service';
import {CmsTranslateService} from '../../shared/translate.service';
import {validateJson} from '../../shared/json-editor/json-validator.directive';

@Component({
    selector: 'cms-add-menu-item',
    templateUrl: 'add-menu-item.component.html'
})

export class CmsAddMenuItemComponent implements OnInit {
    menuItem: FormGroup;
    titleValidationInterpolationParams;

    constructor(
        private modalService: CmsModalService,
        private fb: FormBuilder,
        private notifyService: CmsNotifyService,
        private translateService: CmsTranslateService
    ) {
        this.titleValidationInterpolationParams = {
            field: this.translateService.translate('common_title').toLowerCase(),
            maximum: '120'
        };
    }

    ngOnInit() {
        this.menuItem = this.fb.group({
            title: ['', [Validators.required, Validators.maxLength(120)]],
            subtitle: ['', []],
            description: ['', []],
            url: ['', []],
            icon: ['', []],
            active: [true, []],
            disabled: [false, []],
            customData: [{}, [validateJson]]
        });
    }

    addItem() {
        this.notifyService.notify({
            type: 'addItem',
            data: {
                fields: this.menuItem.value
            }
        });

        this.closePopup();
    }

    closePopup() {
        this.modalService.close('add-menu-item');
    }
}
